import { createRef } from "react";
import { isChildrenLoaded } from "./ContainerUtil";
import { UniqueContainerId } from "../UniqueContainerId/UniqueContainerId";
var ContainerRefs = /** @class */ (function () {
    function ContainerRefs(tree) {
        var _this = this;
        this.addItemRefs = function (tree) {
            for (var _i = 0, tree_1 = tree; _i < tree_1.length; _i++) {
                var node = tree_1[_i];
                var uniqueId = UniqueContainerId.fromContainerTreeData(node);
                _this.set(uniqueId, createRef());
                if (isChildrenLoaded(node.childData)) {
                    _this.addItemRefs(node.childData.childrenData);
                }
            }
        };
        this.map = new Map();
        if (tree) {
            this.addItemRefs(tree);
        }
    }
    ContainerRefs.prototype.set = function (uniqueContainerId, value) {
        this.map.set(uniqueContainerId.toString(), value);
    };
    ContainerRefs.prototype.size = function () {
        return this.map.size;
    };
    ContainerRefs.prototype.get = function (uniqueContainerId) {
        return this.map.get(uniqueContainerId.toString());
    };
    return ContainerRefs;
}());
export { ContainerRefs };
//# sourceMappingURL=ContainerRefs.js.map